import { combineEpics } from 'redux-observable';

const epics = combineEpics();
export default epics;
